import type { ReactNode } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { format, parseISO } from 'date-fns'
import { useFiltros } from '../state/FiltrosContext'

const br = (isoDate: string) => format(parseISO(isoDate), 'dd/MM/yyyy')

/** Cabeçalho comum dos painéis: título, de onde vêm os dados, o recorte ativo e o conteúdo. */
export function PainelShell({
  titulo,
  fontes,
  children,
}: {
  titulo: string
  /** Ex.: "Meta Ads · Google Ads" — o leitor sabe de onde sai cada número. */
  fontes: string
  children: ReactNode
}) {
  const { intervalo, marcaId, marcas } = useFiltros()
  const marca = marcas.find((m) => m.id === marcaId)?.nome ?? 'Todas as marcas'
  const datas =
    intervalo.inicio === intervalo.fim
      ? br(intervalo.inicio)
      : `${br(intervalo.inicio)} a ${br(intervalo.fim)}`

  return (
    <Stack spacing={2}>
      <Box>
        <Typography
          variant="h5"
          sx={{ fontFamily: '"Outfit", sans-serif', fontWeight: 700, lineHeight: 1.2 }}
        >
          {titulo}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {fontes} · {datas} · {marca}
        </Typography>
      </Box>
      {children}
    </Stack>
  )
}
